import { Link } from "react-router-dom";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_ataiwo-elektricien/artifacts/wzrouhde_2868CD89-A0CA-4FF0-8FAA-6411D6FA51B6.png";

// Kept for backwards-compat: some places imported LogoMark
export function LogoMark({ className = "w-9 h-9" }) {
  return (
    <img src={LOGO_URL} alt="Ataiwo Installatietechniek" className={`${className} object-contain`} />
  );
}

export function BrandLogo({ size = "md", className = "" }) {
  const heights = { sm: "h-9", md: "h-12 md:h-14", lg: "h-16 md:h-20" };
  const h = heights[size] || heights.md;
  return (
    <Link to="/" data-testid="nav-logo" className={`inline-flex items-center ${className}`}>
      <img
        src={LOGO_URL}
        alt="Ataiwo Installatietechniek — Elektricien Amsterdam &amp; Noord-Holland"
        className={`${h} w-auto object-contain`}
        loading="eager"
        decoding="async"
      />
    </Link>
  );
}
